import { type FC } from 'react';
import {
  UiStack,
  UiText,
} from '@/lib/ui';
// import BaseMessageBarError from '@/base/MessageBar/Error';
// import BaseRouterLink from '@/base/Router/Link';
// import { generatePageUrl } from '@/app/pages';

export interface ApiErrorAccessDeniedProps {
}

const ApiErrorAccessDenied: FC<ApiErrorAccessDeniedProps> = () => {
  // const loginUrl = useMemo(() => generatePageUrl('AccountLoginLoginEmail'), []);

  return (
    <UiStack>
      <UiText color={'red.500'}>Operation failed. Insufficient permissions.</UiText>
    </UiStack>
  );
};

export default ApiErrorAccessDenied;
